/* eslint-disable */
import styles from './index.module.scss'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useParams } from 'react-router-dom'
import { useState, useContext, useEffect, useRef } from 'react'
import { BreadcrumbArrow, SearchIcon } from '../../icons'
import { Link } from 'react-router-dom'
import Loading from '../../components/pages/loading'
import LoadGif from '../../assets/images/load.gif'
import 'swiper/css'
import SearchAPI from '../../api/search'
import './styles.css'

const Calendar = ({ className }) => {
  const { query } = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [load2, setLoad2] = useState(true)
  const inputRef = useRef(null)
  const [result, setResult] = useState([])

  useEffect(() => {
    (async () => {

    const { data } = await SearchAPI.getSearch(query, language)
    await setResult(data)
    setLoad(true)
  
    })();
  }, [])
  const getInput = async (e) => {
    let val = await inputRef.current.value.trim()
    let length = await val.split('').length
    if (length > 3) {
      await setLoad2(false)
      const { data } = await SearchAPI.getSearch(val, language)
      await setResult(data)
      await setLoad2(true)
    }
  }
  const generateLink = (item) => {
    switch (item.type) {
      case 'service':
        window.location.href = `/services/${item.id}`
        break
      case 'news':
        window.location.href = `/news/${item.id}`
        break
      default:
        window.location.href = `/`
    }
  }
  useEffect(() => {
    (async () => {

    await setLoad(true)
  
    })();
  }, [])
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <div className={styles.header}>
        <div className={styles.breadcrumb}>
          <Link to={'/'}>{translate.home[language]}</Link>
          <BreadcrumbArrow />
          <Link to={'#'}>{translate.search[language]}</Link>
        </div>
        <h1>{translate.search[language]}</h1>
        <label className={styles.search}>
          <SearchIcon />
          <input
            ref={inputRef}
            onKeyUp={(e) => {
              getInput(e)
            }}
            type="text"
            placeholder={translate.search[language]}
          />
        </label>
      </div>
      <div className={styles.content}>
        {load2 ? (
          <ul>
            {result.length ? (
              result.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    generateLink(item)
                  }}
                >
                  <h2>{item.title}</h2>
                  <p dangerouslySetInnerHTML={{ __html: item.text }} />
                  ...
                </li>
              ))
            ) : (
              <p>{translate.no_result[language]}</p>
            )}
          </ul>
        ) : (
          <div className={styles.load}>
            <img src={LoadGif} alt="Loading..." />
          </div>
        )}
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Calendar
